import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import { ChipProps } from 'app/core/json-schema-controls/models/chip-props.model';
import { Observable, filter, of, startWith, switchMap } from 'rxjs';
import { JsonSchemaService } from '../../../services/json-schema.service';

interface ChipItem {
  name: string;
  value: string;
}

@Component({
  selector: 'hmt-chip-type',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './chip-type.component.html',
  styleUrl: './chip-type.component.scss',
})
export class ChipTypeComponent extends FieldType<FormlyFieldConfig<ChipProps>> implements OnInit {
  @Input() items: ChipItem[] = [];
  @Input() staticComponent = false;

  constructor(private jsonSchemaService: JsonSchemaService) {
    super();
  }

  ngOnInit(): void {
    this.items = this.staticComponent ? this.items : this.props.items || [];
    this.formControl.valueChanges
      .pipe(
        startWith(''),
        switchMap((value: string) => {
          if (this.staticComponent) {
            this.items = this.items.filter(i => i.name.includes(value));
            return this.items;
          } else {
            return this.loadData(this.props.url).pipe(filter((data: ChipItem[]) => !!data && data.length > 0));
          }
        })
      )
      .subscribe();
    this.formControl.setValue(this.items);
  }

  loadData(url: string): Observable<ChipItem[]> {
    if (url) {
      return this.jsonSchemaService.loadValues(url);
    }
    return of([]);
  }

  remove(item: ChipItem): void {
    this.items = this.items.filter(i => i.name !== item.name);
    this.formControl.setValue(this.items);
  }

  get styleObject(): Record<string, string> {
    return this.jsonSchemaService.cssStringToObject(this.props?.styles || '');
  }
}
